import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { translationResources } from "./resources";
import { DEFAULT_UI_LANGUAGE, normalizeUiLanguage } from "./uiLanguages";

const stored = typeof window !== "undefined" ? localStorage.getItem("xentros_lang") : null;
const lng = normalizeUiLanguage(stored) ?? DEFAULT_UI_LANGUAGE;

i18n.use(initReactI18next).init({
  // XEN-152: use only bundled resources. Never send missing labels or
  // interpolated guest/financial data to a translation service.
  resources: translationResources,
  lng,
  fallbackLng: "en",
  saveMissing: false,
  interpolation: { escapeValue: false }, 
});

export default i18n;
